var _path, _g, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigmaConnectedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 56,
    viewBox: "0 0 208 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5785 43.0996H44.3364C40.3462 47.2996 34.7518 49.9579 28.4943 49.9579C22.2255 49.9579 16.5745 47.3223 12.5785 43.0996ZM28.5 6.0421C34.7745 6.0421 40.4255 8.67773 44.4158 12.9004H12.6579C16.6482 8.69474 22.2425 6.0421 28.5 6.0421ZM28.5 0C16.2117 0 5.7996 7.92955 2.03036 18.9368H48.4741C49.33 20.8243 49.9364 22.8478 50.2312 24.9789H0.67004C0.562348 25.9708 0.5 26.9798 0.5 28C0.5 43.4623 13.0377 56 28.5 56C40.7883 56 51.2004 48.0704 54.9696 37.0632H8.53158C7.67571 35.1757 7.06923 33.1522 6.77449 31.021H56.33C56.4377 30.0291 56.5 29.0202 56.5 28C56.5 12.5377 43.9623 0 28.5 0Z",
    fill: "url(#paint0_linear_970_9405)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_970_9405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M179.973 28.1021C179.973 23.1487 183.988 19.1333 188.941 19.1333H189.166C194.119 19.1333 198.134 23.1487 198.134 28.1021C198.134 33.0554 194.119 37.0708 189.166 37.0708H188.941C183.988 37.0708 179.973 33.0554 179.973 28.1021Z",
    fill: "#1ABCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.6 46.6375C160.6 41.3539 164.883 37.0708 170.167 37.0708H179.973V46.5179C179.973 51.8675 175.576 56.2041 170.226 56.2041C164.943 56.2041 160.6 51.921 160.6 46.6375Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.973 0V19.1333H188.568C193.851 19.1333 198.134 14.8502 198.134 9.56667C198.134 4.28314 193.851 0 188.568 0L179.973 0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.6 9.56663C160.6 14.8502 164.883 19.1333 170.167 19.1333L179.973 19.1333V-3.24249e-05L170.167 -3.24249e-05C164.883 -3.24249e-05 160.6 4.28311 160.6 9.56663Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.6 28.1021C160.6 33.0554 164.616 37.0708 169.569 37.0708H179.973V19.1333L169.569 19.1333C164.616 19.1333 160.6 23.1487 160.6 28.1021Z",
    fill: "#A259FF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 36.144C78.1667 38.9773 96.5 41.644 108.5 29.644C115.5 21.644 110.159 17.1175 104 18.144C102.5 18.394 99 20.144 100.5 23.644C102.5 27.144 108 34.144 115.5 35.144C123 36.144 137.5 34.144 145 23.644",
    stroke: "url(#paint1_linear_970_9405)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "3 3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_970_9405",
    x1: 0.499994,
    y1: 28,
    x2: 56.5,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2074,
    stopColor: "#4441DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2709,
    stopColor: "#5242D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3908,
    stopColor: "#7744B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5531,
    stopColor: "#B2478E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ED4A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7340"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_970_9405",
    x1: 70.5,
    y1: 38.5537,
    x2: 145,
    y2: 38.5537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6238F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.800806,
    stopColor: "#F44A64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7340"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_970_9405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white",
    transform: "translate(151.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaConnectedIcon);
export default __webpack_public_path__ + "static/media/figma-connected-icon.8e9e54c1366e3e2a56290d105e10cab0.svg";
export { ForwardRef as ReactComponent };